export default __webpack_public_path__ + "static/media/INC Straight Flush.f09acee1.mp3";